import Client from './axiosClient'

export default {
  get(resource) {
    return Client.get(`${resource}`);
  },

  getById(resource,id) {
    return Client.get(`${resource}/${id}`);
  },

  create(resource,payload) {
    return Client.post(`${resource}`, payload);
  },

  update(resource,payload, id) {
    return Client.put(`${resource}/${id}`, payload);
  },

  uploadMedia(resource, payload) {
    return Client.post(`${resource}`, payload);
  },

  sendMail(resource, payload) {
    return Client.post(`${resource}`, payload);
  }

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/commonRepository.js